import { store } from '../../store';
import {
  setSummaryLoading,
  setSummaryComplete,
  setSummaryError,
} from '../../store/summaryTest/slice';
import { SocketMessage } from '../types';

// Summary update types
export enum SummaryUpdateStatus {
  Loading = 'loading',
  Complete = 'complete',
  Error = 'error',
}

export interface SummaryUpdatePayload {
  status: SummaryUpdateStatus;
  summary?: string;
  metadata?: {
    companyName: string;
    documentCount: number;
    sectionCount: number;
    totalTokens: number;
    generationTime: number;
  };
  error?: string;
}

export function summaryUpdateHandler(message: SocketMessage<SummaryUpdatePayload>): void {
  const payload = message.payload as SummaryUpdatePayload;

  if (!payload || !payload.status) {
    console.error('Invalid summary update payload:', payload);
    return;
  }

  switch (payload.status) {
    case SummaryUpdateStatus.Loading:
      store.dispatch(setSummaryLoading());
      break;
    case SummaryUpdateStatus.Complete:
      if (payload.summary && payload.metadata) {
        store.dispatch(
          setSummaryComplete({
            summary: payload.summary,
            metadata: payload.metadata,
          }),
        );
      } else {
        console.error('Missing summary or metadata in complete payload:', payload);
        store.dispatch(setSummaryError('Invalid response from server'));
      }
      break;
    case SummaryUpdateStatus.Error:
      store.dispatch(setSummaryError(payload.error || 'Unknown error occurred'));
      break;
    default:
      console.error('Unknown summary status:', payload.status);
      store.dispatch(setSummaryError('Unknown status received from server'));
  }
}
